import React, { useState } from 'react';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import enGB from 'date-fns/locale/en-GB';
import 'react-datepicker/dist/react-datepicker.css';
import './EnglishDatePicker.css';

registerLocale('en-GB', enGB);

const EnglishDatePicker = ({
  selected,
  onChange,
  minDate,
  maxDate,
  disabled = false,
  placeholderText = "DD/MM/YYYY",
  dateFormat = "dd/MM/yyyy"
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleDateChange = (date) => {
    onChange(date);
    setIsOpen(false);
  };

  const formatDate = (date) => {
    if (!date) return '';
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, '0');
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  return (
    <>
      <input
        type="text"
        value={selected ? formatDate(selected) : ''}
        placeholder={placeholderText}
        onClick={() => !disabled && setIsOpen(true)}
        readOnly
        disabled={disabled}
        className="datepicker-input"
      />

      {isOpen && (
        <div className="datepicker-modal-overlay" onClick={() => setIsOpen(false)}>
          <div className="datepicker-modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="datepicker-modal-header">
              <h3>اختر التاريخ</h3>
              <button className="datepicker-modal-close" onClick={() => setIsOpen(false)}>
                ×
              </button>
            </div>
            <DatePicker
              locale="en-GB"
              selected={selected}
              onChange={handleDateChange}
              minDate={minDate}
              maxDate={maxDate}
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              inline
            />
          </div>
        </div>
      )}
    </>
  );
};

export default EnglishDatePicker;